export default __webpack_public_path__ + "static/media/dots.cfa25637.svg";